/**
 * SEO "Industries (expanded)": industry tabs + one-open-at-a-time accordion.
 */
document.addEventListener('DOMContentLoaded', function () {
    var tabBtns = document.querySelectorAll('.ind-tab-btn');
    var panes = document.querySelectorAll('.ind-pane');

    tabBtns.forEach(function (btn) {
        btn.addEventListener('click', function () {
            tabBtns.forEach(function (b) { b.classList.remove('active'); });
            panes.forEach(function (p) { p.classList.remove('active'); });

            btn.classList.add('active');
            var pane = document.getElementById(btn.getAttribute('data-target'));
            if (pane) pane.classList.add('active');
        });
    });

    document.querySelectorAll('.ind-accordion-item').forEach(function (acc) {
        var header = acc.querySelector('.ind-accordion-header');
        var body = acc.querySelector('.ind-accordion-body');
        if (!header || !body) return;

        header.addEventListener('click', function () {
            var isOpen = acc.classList.contains('open');

            acc.closest('.ind-accordion').querySelectorAll('.ind-accordion-item').forEach(function (item) {
                item.classList.remove('open');
                item.querySelector('.ind-accordion-body').style.display = 'none';
            });

            if (!isOpen) {
                acc.classList.add('open');
                body.style.display = 'block';
            }
        });
    });
});
